import React from 'react'
import styles from "./Dashboardheader.module.css"
import { Link, useParams } from 'react-router-dom'
import { ReactComponent as Icon1 } from "../../Icon/folders.svg"
import { ReactComponent as Icon2 } from "../../Icon/folder-share.svg"
import { ReactComponent as Icon3 } from "../../Icon/trash.svg"
import { ReactComponent as Icon4 } from "../../Icon/free-rights.svg"
import ThemeButton from '../../Themes/ThemeButton'
import { useTheme } from '../../Themes/ThemeContext'

const Dashboardheader = () => {
    const { theme } = useTheme()
    const Icons = [Icon1, Icon2, Icon3, Icon4]

    let links = [{
        title: "My Projects",
        icon: "/images/Redesignpics/Dashboard/folders.svg",
        url: '/dashboard/myprojects'
    },
    {
        title: "Shared Projects",
        icon: "/images/Redesignpics/Dashboard/folder-share.svg",
        url: '/dashboard/sharedprojects'
    }, {
        title: "Trash",
        icon: "/images/Redesignpics/Dashboard/trash.svg",
        url: '/dashboard/trashedprojects'
    },
    {
        title: "Plan & Pricing",
        icon: "/images/Redesignpics/Dashboard/free-rights.svg",
        url: '/dashboard/plan&pricing'
    }]

    const { project } = useParams();

    // console.log(project);

    const handleSearch = () => {

    }

    return (
        <div className={styles.dashboard_outer}>
            <div className={styles.dashboard_top}>
                <div className={styles.editlatexlogo}>
                    {theme === "dark" ? <img src={process.env.PUBLIC_URL + "/images/dark-logo.png"} alt='editlatex_logo' /> : <img src={process.env.PUBLIC_URL + "/images/white-logo.png"} alt='editlatex_logo' />}
                </div>
                {/* <div className={styles.searchfield}>
                    <input onChange={handleSearch} className={styles.search_input} type='text' placeholder='Search in your projects' />
                </div> */}
            </div>
            <div className={styles.dashboard_theme}>
                <div className={styles.dashboard_links}>
                    {
                        links.map((item, index) => {
                            const Icon = Icons[index]
                            return (
                                <Link to={item.url} key={index} className={`${styles.listitems} ${item.url.includes(project) ? styles.underline : ""}`}>
                                    {/* <img src={process.env.PUBLIC_URL + item.icon} alt='logo' /> */}
                                    <Icon />
                                    <p>{item.title}</p>
                                </Link>
                            )
                        })
                    }


                </div>
                <ThemeButton />
            </div>

        </div >
    )
}

export default Dashboardheader